import { ReactNode, useCallback, useMemo, useState } from 'react';

import { ModalRequest, modals } from '@/modals';
import { ModalsContext } from '@/modals/context';
import ResetLocationModal from '@/modals/ResetLocationModal';
import ResetPermissionsModal from '@/modals/ResetPermissionsModal';

export default function ModalsProvider({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState<ModalRequest | null>(null);

  const imperativeModals = useMemo(() => ({
    show(request: ModalRequest) {
      setRequest(request);
    },
  }), []);

  const close = useCallback(() => setRequest(null), []);

  return (
    <ModalsContext.Provider value={imperativeModals}>
      {children}
      {request?.modal === modals.RESET_PERMISSIONS_MODAL && (
        <ResetPermissionsModal onClose={close} permissions={request.permissions} />
      )}
      {request?.modal === modals.RESET_LOCATION_MODAL && (
        <ResetLocationModal onClose={close} />
      )}
    </ModalsContext.Provider>
  );
}
